import { render, staticRenderFns } from "./ShipFeeOrder.vue?vue&type=template&id=4b99b84b&"
import script from "./ShipFeeOrder.vue?vue&type=script&lang=js&"
export * from "./ShipFeeOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShipFeeOrder.vue?vue&type=style&index=0&id=4b99b84b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports